export default "__VITE_ASSET__5O4QNdRj__"